import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';

const NavigationContainer = styled(Container)(({ theme }) => ({
  width: '100%',
  height: '100%',
  overflow: 'auto',
  cursor: 'pointer',

  [theme.breakpoints.down('md')]: {
    '& .MuiPaper-root': {
      width: '100% !important',
      height: '100% !important',
      backgroundColor: '#00FF00 !important',
      left: '0 !important'
    },
    '& .MuiSvgIcon-root path': {
      fill: '#fff !important',
    },
  },
}));

export default NavigationContainer;
